"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get down () {
        return down;
    },
    get up () {
        return up;
    }
});
const _globals = require("~/utils/globals");
const up = async (knex)=>{
    await knex.schema.createTable(_globals.MetaTable.INTEGRATIONS_STORE, (table)=>{
        table.string('id', 20).primary();
        table.string('fk_integration_id', 20).index();
        table.string('type', 20);
        table.string('sub_type', 20);
        table.string('fk_workspace_id', 20);
        table.string('fk_user_id', 20);
        table.timestamps(true, true);
        table.text('slot_0');
        table.text('slot_1');
        table.text('slot_2');
        table.text('slot_3');
        table.text('slot_4');
        table.integer('slot_5');
        table.integer('slot_6');
        table.integer('slot_7');
        table.integer('slot_8');
        table.integer('slot_9');
    });
};
const down = async (knex)=>{
    await knex.schema.dropTable(_globals.MetaTable.INTEGRATIONS_STORE);
};
